import React, { useState } from "react";
import "../component/staffHeader.css";

import { FaPlusCircle } from "react-icons/fa";

const StaffHeader = ({ onAddStaffClicked, onSearchStaff }) => {
  const [searchValue, setSearchValue] = useState(
    localStorage.getItem("searchValue")
  );
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
    e.preventDefault();
    if (errorMessage && e.target.value >= 3) {
      setErrorMessage("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      localStorage.setItem("searchValue", searchValue);
      e.preventDefault();
      if (searchValue.length > 2) {
        onSearchStaff(searchValue);
        setErrorMessage("");
      } else if (searchValue.length === 0) {
        onSearchStaff(searchValue);
        setErrorMessage("");
      } else {
        setErrorMessage("Pencarian membutuhkan minimal lebih dari 3 huruf");
      }
    }
  };

  return (
    <div className="staff-header-container">
      <button className="add-staff-button" onClick={onAddStaffClicked}>
        <FaPlusCircle />
        Tambah Staff Baru
      </button>

      <div className="search-container">
        <input
          type="text"
          placeholder="Cari Staff"
          className="search-input"
          value={searchValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </div>
    </div>
  );
};

export default StaffHeader;
